export default "__VITE_ASSET__B$69pBYC__"